import React from 'react';

const PatientMatchReasons = () => {
  const reasons = [
    "Histology, stage, and biomarker profile",
    "No prior immunotherapy",
    "Adequate organ function",
    "Lives within recruitment area"
  ];
  
  return (
    <div className="bg-white p-4 rounded-lg shadow mb-4">
      <h3 className="text-lg font-medium mb-3">Why This Patient Matches:</h3>
      
      <ul className="space-y-2">
        {reasons.map((reason, index) => (
          <li key={index} className="flex items-start">
            <span className="mr-2">•</span>
            <span>{reason}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PatientMatchReasons;